<script setup>
import { langTypes } from "@/utils/constant"
import ContentError from "@/components/common/ContentError.vue"
import BtnLang from "@/components/BtnLang.vue"
definePage({
  meta: {
    layout: "blank",
    unauthenticatedOnly: false,
  },
})
import StudentService from "@/services/StudentService"
import { $gettext } from "@/services/ApiService"
import { useCustomSwal } from "@/composables/usePopup"
const { showCustomSwal } = useCustomSwal()

const errorData = ref(null)
const info = ref({})
const route = useRoute()
const CURRENT_YEAR = import.meta.env.VITE_CURRENT_YEAR || 2026
const isLoading = ref(false)
const isDisabled = ref(false)
const isRefresh = ref(false)

const onSubmit = async (obj) => {
  isDisabled.value = true
  try {
    await StudentService.updateRegister({
      ...obj,
      programId: info.value?.program?.id,
    })
    await showCustomSwal({
      showCancelButton: false,
      showConfirmButton: false,
      showCloseButton: true,
      timerProgressBar: true,
      timer: 10000,
      width: 490,
      position: "center",
      title: $gettext("Data successfully saved"),
      text: $gettext("An email containing a participation link has been sent to you."
      ),
      footer: `<div>
        ${$gettext("If you do not receive it: check your spam folder.")}
        </div>
        ${$gettext("If you have nothing in your spam folder,")} 
        <div>
          <b>${$gettext("DO NOT REGISTER AGAIN")}</b> 
          ${$gettext("and contact us by email at:")}
        </div>
        <div><a href='mailto:mastersurvey@eduniversal-group.com'>mastersurvey@eduniversal-group.com</a></div>
        `,
    }).then(() => {
      isDisabled.value = false
    })
  } catch (error) {
    errorData.value = error?.data
    if (error?.data?.message) {
      await showCustomSwal({
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
        timerProgressBar: true,
        timer: 10000,
        width: 490,
        position: "center",
        // icon: "error",
        html: `<div class="font-weight-regular">${error?.data?.message}</div>`,
      }).then(() => {
        isDisabled.value = false
      })
    }
  }
}

const onChangeLang = (lang) => {
  const locale = langTypes.find((x) => x.id === lang)
  if (locale) {
    const urlObj = new URL(window.location.href)
    urlObj.searchParams.set("lang", locale.name) // Replace 'en' with your desired language
    const newUrl = urlObj.toString()
    window.location.href = newUrl
  }
}

onMounted(async () => {
  const { params } = route
  try {
    const res = await StudentService.getRegister(params.id)
    info.value = res || {}
  } catch (error) {
    errorData.value = error?.data
  }
})
</script>

<template>
  <div class="register-student">
    <div class="register-student__container" style="max-width: 900px">
      <div class="register-student__bg">
        <img src="@/assets/images/palm_bg.svg" alt="palm" />
      </div>
      <!-- Start Header -->
      <header
        class="d-flex align-center justify-space-between register-student__container-header"
        style="position: relative"
      >
        <RouterLink to="/" class="app-logo app-title-wrapper">
          <img
            src="@/assets/logo-eduniversal.png"
            alt="Logo"
            style="max-width: 140px"
          />
        </RouterLink>
        <div></div>
        <!-- <BtnLang @onChange="onChangeLang" /> -->
      </header>
      <main
        class="register-student__main py-6 px-6 px-md-12"
        style="background: #fff"
      >
        <div>
          <h1>
            {{ $gettext("Eduniversal Programs Surveys") }} {{ CURRENT_YEAR }}
            <div style="font-size: 1.85rem; color: #C99B6C">
              of the Best Master’s, MS and MBA Programs
            </div>
          </h1>
          <!-- <h1 v-else>
            {{ $gettext("Enquêtes") }} Eduniversal {{ CURRENT_YEAR }}
            <div style="font-size: 1.85rem; color: #C99B6C">
              {{ $gettext("des") }} Meilleurs Masters, MS
              {{ $gettext("and") }} MBA
            </div>
          </h1> -->
        </div>

        <hr class="my-4" />
        <div style="max-width: 700px; margin: 0 auto">
          <ContentError v-if="errorData?.code" :code="errorData?.code" />
          <template v-else>
            <div class="form__title">
              <h4>
                {{ $gettext("Your program in") }}
                {{ CURRENT_YEAR - 1 }}/{{ CURRENT_YEAR }}
              </h4>
              <h3>
                {{ info.program?.school?.name }}
              </h3>
              <h3>
                {{ info.program?.name }}
              </h3>
            </div>
            <FormRegisterStudent
              v-if="!isRefresh"
              :loading="isLoading"
              :disabled="isDisabled"
              @update:modelValue="onSubmit"
              :message="errorData && errorData?.message"
              class="mt-4"
            />
          </template>
        </div>
      </main>
      <div
        class="d-flex align-center bg-white px-6 pt-6 pb-10 mt-6"
        style="position: relative; border-radius: 16px"
      >
        <h3 class="text-primary" style="width: 400px">
          {{ $gettext("Still need help?") }}
        </h3>
        <div>
          <div>
            <b>
              {{
                $gettext("Our specialists are always delighted to help."
                )
              }}
            </b>
          </div>
          {{
            $gettext("Contact us during business hours or email us anytime, and we will get back to you."
            )
          }}
        </div>
      </div>

      <div class="text-center" style="margin-top: -18px">
        <v-btn
          href="mailto:mastersurvey@eduniversal-group.com"
          style="border-radius: 36px"
        >
          {{ $gettext("Contact us") }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/pages/register-student.scss";
</style>
